import { combineEpics } from 'redux-observable';
import { clearNotificationEpic } from './clear-notifications';
import { listNotificationsEpic } from './list-notifications';
import { listUserNotificationsEpic } from './list-user-notifications';
import { markAsReadEpic } from './mark-as-read';
import { inviteStatusChangedEpic } from './notification-invite-status-chenged';
import { showLatestSyncNotificationEpic } from './show-latest-sync-notification';

const notificationsEpic = combineEpics(
  listNotificationsEpic,
  listUserNotificationsEpic,
  markAsReadEpic,
  inviteStatusChangedEpic,
  clearNotificationEpic,
  showLatestSyncNotificationEpic
);

export default notificationsEpic;
